<template>
  <div
    class="container-fluid p-2 m-0 text-white text-center bg-offline"
  >
    <div class="fs-16 font-weight-bold">
      <font-awesome-icon
        :icon="['fas', 'wifi']"
        class="mr-1"
      />
      NO INTERNET CONNECTION
    </div>
    <div class="fs-14">
      Please check your Wi-Fi or Mobile Data before continuing with the application
    </div>
    <div class="fs-14 font-weight-bold">
      Leaving the browser, clicking the back button or navigating to another website will require the start of a new application
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        isOnline: 'connection/isOnline'
      })
    },

    mounted () {
      window.dataLayer.push({
        event: 'connection_banner_shown',
        Message: this.message
      });
    },

    beforeDestroy () {
      window.dataLayer.push({
        event: 'connection_banner_hidden'
      });
    }
  };
</script>

<style scoped>
  .fs-16 {
    font-size: 16px;
  }
  .fs-14 {
    font-size: 14px;
  }
  .bg-offline {
    background-color: #ac3544;
  }
</style>
